module.exports = __webpack_public_path__ + "static/sm_img01@2x-6b427a043da169943be8693e45c1877c.jpg";